import Dashboard from "layouts/dashboard";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
// @mui icons
import Icon from "@mui/material/Icon";
import ForgetPassword from "layouts/authentication/reset-password";
import AllUsers from "layouts/users";
import NotificationPage from "layouts/notifications";
import PromotionPage from "layouts/promotion";
import CardDetailsPage from "layouts/settings";
import VoucherPage from "layouts/voucher";
import ProfilePage from "layouts/profile";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />
  },

  {
    type: "collapse",
    name: "Card Details",
    key: "card",
    icon: <Icon fontSize="small">style</Icon>,
    route: "/card",
    component: <CardDetailsPage />
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/users",
    component: <AllUsers />
  },

  // {
  //   type: "collapse",
  //   name: "Billings",
  //   key: "transactions",
  //   icon: <Icon fontSize="small">account_balance_wallet</Icon>,
  //   route: "/transactions",
  //   component: <Billing />
  // },

  {
    type: "collapse",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <NotificationPage />
  },
  {
    type: "collapse",
    name: "Promotions",
    key: "promotions",
    icon: <Icon fontSize="small">local_offer</Icon>,
    route: "/promotions",
    component: <PromotionPage />
  },
  {
    type: "collapse",
    name: "Voucher",
    key: "voucher",
    icon: <Icon fontSize="small">coffee</Icon>,
    route: "/voucher",
    component: <VoucherPage />
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">manage_accounts_icon</Icon>,
    route: "/profile",
    component: <ProfilePage />
  },
  {
    type: "details",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/sign-in",
    component: <SignIn />
  },
  {
    type: "details",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/sign-up",
    component: <SignUp />
  },
  {
    type: "details",
    name: "Forget Password",
    key: "forget-password",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/forget-password",
    component: <ForgetPassword />
  },
  {
    type: "details",
    name: "Payment Success",
    key: "payment-success",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/payment/success",
    component: <Dashboard />
  },
  {
    type: "details",
    name: "Payment Cancel",
    key: "payment-cancel",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/payment/cancel",
    component: <Dashboard />
  }
];

export default routes;
